<template>
  <div class="select">
    <div class="inner" @click="handleShowOptions" v-clickOut="outsideDirec">
      <div class="inputWrapper">
        <input type="text" readonly :placeholder="placeholder" :value="selected" />
        <img :src="showOptions ?  imgSrc.arrowTop:imgSrc.arrowBtn" alt class="icon-arrow" />
      </div>
      <ul class="options" v-show="showOptions">
        <li
          v-for="item in options"
          :key="item.value"
          @click.stop="choose(item,type)"
          :class="{active:selected == item.value}"
        >{{item.value}}</li>
      </ul>
    </div>
  </div>
</template>

<script>
import { StringDecoder } from 'string_decoder';
export default {
  name: "SelectCommon",
  props: {
    options: {
      type: Array,
      default:[]
    },
    placeholder: {
      type: String,
      default: ""
    },
    title: {
      type: String,
      default: ""
    },
    type:{
      type:String,
      default:''
    }
  },
  data() {
    return {
      showOptions: false,
      selected: "", //选择的
      imgSrc: {
        arrowTop: require("@/assets/arrow2.png"),
        arrowBtn: require("@/assets/arrow3.png")
      }
    };
  },
  created() {
    this.selected = this.title;
  },
  directives: {
    clickOut: {
      bind: function(el, binding) {
        function handler(e) {
          if (el.contains(e.target)) return false;
          if (binding.expression) {
            binding.value();
          }
        }

        el.handler = handler;
        document.addEventListener("click", el.handler);
      },
      unbind: function(el) {
        document.removeEventListener("click", el.handler);
      }
    }
  },

  methods: {
    handleShowOptions() {
      if (this.options.length) {
        this.showOptions = !this.showOptions;
      }
    },
    outsideDirec() {
      this.showOptions = false;
    },
    choose(val,type) {
      this.showOptions = false;
      if (val !== this.selected) {
        this.selected = val.value;
        this.$emit("selectValue", val,type);
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.select {
  
  .active {
    color: #409eff;
  }
  .inner {
    position: relative;
    font-size: 12px;
    height: 32px;
    line-height: 32px;
    border:1px solid #dcdfe6 ;
    display: flex;
    justify-content: space-between;
    padding: 0 15px;
    .inputWrapper {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;
      input {
        width: 60px;
        height: 100%;
        border: none;
        background: #fff;
        outline: none;
        color: #109eff;
        cursor: pointer;
      }
      .icon-arrow {
        width: 12px;
        height: 6px;
        margin-right: 0.04rem;
      }
    }
    .options {
      position: absolute;
      left: 0;
      right: 0;
      z-index: 2;
      top: 120%;
      padding: 0.1rem 0;
      background-color: #fff;
      box-shadow: 0 0 4px #ddd;
      border-radius: 3px;
      overflow: auto;
      li {
        padding: 3px 10px;
        cursor: pointer;
        &:hover {
          background-color: #eee;
        }
      }
    }
  }
  &:not(first-child){
      .inner{
          margin-left: -1px;
      }
  }
}
</style>